import { displayDefaultDateTime } from 'app/shared/util/date-utils';

export const columns = [
  {
    title: 'Ngày cập nhật',
    sorter: true,
    key: 'lastedUpdate',
    width: 120,
    dataIndex: 'lastedUpdate',
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Kỳ báo cáo',
    sorter: true,
    key: 'reportScheduleName',
    width: 100,
    dataIndex: 'reportScheduleName',
  },
  {
    title: 'Tình trạng',
    key: 'workStatusName',
    width: 100,
    dataIndex: 'workStatusName',
  },
  {
    title: 'Ngày hoàn thành',
    sorter: true,
    key: 'completedOn',
    width: 120,
    dataIndex: 'completedOn',
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Đã hoàn thành',
    key: 'completeNote',
    width: 250,
    dataIndex: 'completeNote',
  },
  {
    title: 'Lý do không hoàn thành, Tạm dừng, Hủy',
    key: 'unFinishNote',
    width: 250,
    dataIndex: 'unFinishNote',
  },
  {
    title: 'Ngày hoàn thành dự kiến',
    sorter: true,
    key: 'expectedCompleteOn',
    width: 120,
    dataIndex: 'expectedCompleteOn',
    render: item => item && displayDefaultDateTime(item),
  },
  {
    title: 'Kế hoạch kỳ tiếp theo',
    sorter: true,
    key: 'nextPlanPeriodPurpose',
    width: 250,
    dataIndex: 'nextPlanPeriodPurpose',
  },
  {
    title: 'Khó khăn & nguyên nhân',
    key: 'issue',
    width: 250,
    dataIndex: 'issue',
  },
  {
    title: 'Giải pháp & kiến nghị',
    key: 'solution',
    width: 250,
    dataIndex: 'solution',
  },

];
